'use strict';

var ANALYTICS = require('../../../ext/tags').ANALYTICS;

var enabled = false;
module.exports = {
  enable: function enable() {
    enabled = true;
  },
  disable: function disable() {
    enabled = false;
  },
  sample: function sample(span, rate, inherit) {
    if (typeof rate === 'object') {
      this.sample(span, rate[span.context()._name], inherit);
    } else if (rate !== undefined) {
      span.setTag(ANALYTICS, rate);
    } else if (inherit && enabled) {
      span.setTag(ANALYTICS, 1);
    }
  }
};